import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import finesManager from 'assets/images/fines_manager.png';

import {
  ActionPortal,
  Checkbox,
  DefaultActionButtons,
  Form,
  Icon,
  Step,
  Switch,
  Text,
} from 'components';

import { Gray, Orange, Purple } from 'constants/colors';
import { StepPropTypes } from 'constants/propTypes';

export default function FinesManager(props) {
  const {
    theme,
    onSubmit,
    onCancel,
    initialValues: defaultValues,
  } = props;

  const {
    control, handleSubmit, register, watch, setValue,
  } = useForm({
    mode: 'all',
    defaultValues: defaultValues || {
      fineManager: true,
      acceptTerms: false,
    },
  });

  const fineManager = watch('fineManager');
  const acceptTerms = watch('acceptTerms');

  const canProceed = !fineManager || (fineManager && acceptTerms);

  useEffect(() => {
    if (!fineManager) {
      setValue('acceptTerms', false);
    }
  }, [fineManager, setValue]);

  const submitForm = (e) => {
    e.preventDefault();
    handleSubmit(onSubmit)();
  };

  return (
    <div style={{ height: '100%', backgroundColor: Gray[200] }}>
      <Step
        headerTitle="Atualização Automática das Multas"
        style={{
          height: '100%', display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: Gray[200],
        }}
        headerSubtitle="Tenha controle total das multas e facilite a sua rotina."
      >
        <Form onKeyPress={(e) => e.key === 'Enter' && submitForm(e)}>
          <div style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            gap: '20px',
            justifyContent: 'space-evenly',
          }}
          >
            <div style={{
              border: `1px solid ${Gray[250]}`,
              backgroundColor: Gray[100],
              borderRadius: '5px',
              padding: '20px',
              width: '50%',
              minHeight: '600px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}
            >
              <Text
                color={Gray[500]}
                fontSize="30px"
                lineHeight="36px"
                fontWeight="700"
              >
                Atualização Automática das Multas
              </Text>
              <Text
                color={Gray[400]}
                fontSize="16px"
                lineHeight="21px"
                fontWeight="400"
              >
                Existe um opcional no módulo de multas do Contele Fleet, onde as infrações de trânsito são atualizadas semanalmente de forma automática. Essa consulta nos órgãos autuadores tem um pequeno custo adicional.
              </Text>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                border: `2px solid ${Purple[400]}`,
                borderRadius: '5px',
                padding: '20px',
                height: '100%',
                width: '100%',
                marginTop: '20px',
                position: 'relative',
              }}
              >
                <div style={{
                  width: '270px',
                  height: '44px',
                  border: `1px solid ${Gray[250]}`,
                  borderRadius: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-40px',
                  position: 'absolute',
                  backgroundColor: Gray[100],
                }}
                >
                  <Switch
                    control={control}
                    name="fineManager"
                    id="fineManager"
                    innerRef={register}
                  />
                  <Text
                    color={Gray[500]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Quero incluir a atualização
                  </Text>
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                  gap: '20px',
                  padding: '20px',
                  width: '100%',
                  height: '100%',
                }}
                >
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                  }}
                  >
                    <Text
                      color={Gray[500]}
                      fontSize="14px"
                      lineHeight="19px"
                      fontWeight="500"
                    >
                      Adicional
                    </Text>
                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                      <Text
                        color={Gray[500]}
                        fontSize="24px"
                        lineHeight="29px"
                        fontWeight="700"
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        R$ 6,00
                      </Text>
                      <Text
                        color={Gray[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        /mês por veículo
                      </Text>
                    </div>
                  </div>

                  <div
                    style={{
                      height: '70%',
                      width: '1px',
                      backgroundColor: Gray[250],
                    }}
                  />

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                  }}
                  >
                    <Text
                      color={Gray[500]}
                      fontSize="16px"
                      lineHeight="19px"
                      fontWeight="700"
                    >
                      Benefícios
                    </Text>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <Icon
                        icon="solidCircleCheck"
                        style={{ fontSize: '15px' }}
                        color="green"
                      />
                      <Text
                        color={Gray[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        Recebimento rápido da multa
                      </Text>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <Icon
                        icon="solidCircleCheck"
                        style={{ fontSize: '15px' }}
                        color="green"
                      />
                      <Text
                        color={Gray[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        Auxilia na identificação do condutor infrator
                      </Text>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <Icon
                        icon="solidCircleCheck"
                        style={{ fontSize: '15px' }}
                        color="green"
                      />
                      <Text
                        color={Gray[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        Mais tempo para pagar as multas com desconto
                      </Text>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <Icon
                        icon="solidCircleCheck"
                        style={{ fontSize: '15px' }}
                        color="green"
                      />
                      <Text
                        color={Gray[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        Reduz as chances de multas NIC
                      </Text>
                    </div>

                  </div>

                </div>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                backgroundColor: Gray[200],
                borderRadius: '5px',
                padding: '20px',
                marginTop: '20px',
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Icon
                    color={Gray[400]}
                    icon="exclamationCircle"
                    style={{ width: '16px', height: '16px' }}
                  />
                  <Text
                    color={Gray[400]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Multas
                  </Text>
                </div>
                <Text
                  color={Gray[400]}
                  fontSize="14px"
                  lineHeight="19px"
                  fontWeight="400"
                >
                  As consultas são realizadas semanalmente nos órgãos autuadores de todo o Brasil, sendo os dados coletados conforme a disponibilidade de informações em cada portal. Por esse motivo, a assertividade é de aproximadamente 90%, já que alguns órgãos menores não possuem informações publicamente disponíveis.
                </Text>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    type="checkbox"
                    control={control}
                    name="acceptTerms"
                    id="acceptTerms"
                    innerRef={register({
                      required: fineManager,
                    })}
                  />
                  <Text
                    color={Gray[400]}
                    fontSize="14px"
                    lineHeight="19px"
                    fontWeight="400"
                    textAlign="center"
                  >
                    Sim, estou ciente dos termos e custos.
                  </Text>
                </div>
              </div>
              
              {fineManager && !canProceed && (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  backgroundColor: Orange[100],
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '12px',
                }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Icon
                      color={Orange[400]}
                      icon="exclamationTriangle"
                      style={{ width: '16px', height: '16px' }}
                    />
                    <Text
                      color={Orange[400]}
                      fontSize="16px"
                      lineHeight="19px"
                      fontWeight="700"
                    >
                      Requisitos para Prosseguir
                    </Text>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                  }}
                  >
                    {fineManager && !acceptTerms && (
                      <Text
                        color={Orange[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        • É necessário aceitar os termos e custos da atualização automática de multas
                      </Text>
                    )}
                  </div>
                </div>
              )}
            </div>
            <img
              src={finesManager}
              alt="Fines Manager"
              style={{ width: '35%', height: '400px' }}
            />
          </div>

          <ActionPortal>
            <DefaultActionButtons
              theme={theme}
              backButtonStyle={{
                iconPosition: 'left', border: 'none', customBackgroundColor: 'transparent', customIconColor: Gray[400], customTextColor: Gray[400], title: 'Passo Anterior',
              }}
              nextButtonStyle={{
                customBackgroundColor: Purple[500], customIconColor: Gray[100], customTextColor: Gray[100], title: 'Próximo Passo',
              }}
              onCancel={onCancel}
              onSubmit={() => handleSubmit(onSubmit)()}
              isValid={canProceed}
            />
          </ActionPortal>
        </Form>
      </Step>
    </div>
  );
}

FinesManager.propTypes = StepPropTypes;
